module.exports = __webpack_public_path__ + "img/0Q3B7497_BlackMatted.06f1ff51.jpg";